<template>
  <div class="rule-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="content" @touchmove.stop>
          <div class="rule-h1">活动规则</div>
          <div class="rule-h2">一、活动入口和权益领取路径</div>
          <section class="rule-block">
            <p class="rule-p">手机银行APP-活动中心-财富晋升计划</p>
          </section>

          <div class="rule-h2">二、活动规则</div>
          <section class="rule-block">
            <p class="rule-p">
              1、活动对象：2025年年末为白金等级，且2026年1月至3月等级均为白金以下等级的客户。
            </p>
            <div class="rule-h4">2、活动时间</div>
            <p class="rule-p">活动参与时间：2026年4月24日-2026年6月30日</p>
            <p class="rule-p">权益领取时间：2026年5月5日-2026年7月31日</p>
            <div class="rule-h4">3、活动规则</div>
            <p class="rule-p">
              2026年4月至6月任一月，客户等级升级为白金或以上等级，即有机会领取实物礼品一份（以下权益三选一），礼品共500份，<span
                class="rule-em rule-em--red"
                >每月限量150份</span
              >，当月未领取完毕，自动延续至下月，先到先得，<span
                class="rule-em rule-em--red"
                >领完即止</span
              >。
            </p>
            <p class="rule-p">权益1：COSTA 弹跳保温杯350ml</p>
            <p class="rule-p">权益2：金龙鱼御品黄金产地稻花香5KG</p>
            <p class="rule-p">
              权益3：潘婷3分钟奇迹臻养洗发水300g+多效修护损伤护发素180ml
            </p>
            <p class="rule-p rule-p--strong">领取须知：</p>
            <p class="rule-p rule-p--strong">
              （1）获奖客户需在活动页面选择心仪的实物权益，并填写有效的收货信息。
            </p>
            <p class="rule-p rule-p--strong">
              （2）奖品将在客户填写信息后，于5个工作日内安排寄出。
            </p>
            <p class="rule-p rule-p--strong">
              （3）活动期间，每位符合资格的客户仅可领取一次奖励。
            </p>
            <div class="rule-h4">4、VIP会员判断标准：</div>
            <p class="rule-p">
              我行将于每月5日前根据您上个月的月日均综合贡献值对您的客户等级进行调整，包括维持、提升或降低。综合贡献值达标情况可登录我行手机银行APP查询或详询您的专属客户经理或支行网点。
            </p>
            <p class="rule-p">等级要求如下：</p>
            <p class="rule-p">(1) 私钻客户：综合贡献值达3000000（含）以上</p>
            <p class="rule-p">
              (2) 黑金客户：综合贡献值达1000000（含）-3000000（不含）
            </p>
            <p class="rule-p">
              (3) 白金客户：综合贡献值达300000（含）-1000000（不含）
            </p>
            <p class="rule-p">
              (4) 星级客户：综合贡献值达10000（含）-300000（不含）
            </p>
          </section>

          <div class="rule-h2">三、温馨提示</div>
          <section class="rule-block">
            <p class="rule-p">
              （一）参与默认规则：参与活动即视为同意活动规则，提醒参与者提前仔细阅读。
            </p>
            <p class="rule-p">
              （二）免责声明：因客户操作不当或网络、运营商故障等非银行可控原因致无法参与活动，我行不予负责。
            </p>
            <p class="rule-p">
              （三）规则变动权：银行可依活动实际情况，在法律允许范围内变动调整活动规则，并通过手机银行客户端、银行公众号公布，公布后即时生效。
            </p>
            <p class="rule-p">
              （四）支持与客服：本活动由易点生活电子商务有限公司支持。领取有问题工作日9:00-21:00拨打400-662-7299；其他疑问每日8:30-20:00拨打厦门国际银行客服热线956085。
            </p>
          </section>
        </div>
        <div class="close-btn" @click="onClose">
          <img src="@/assets/imgs/xibReturnGift/rule_close.png" alt="close" />
        </div>
      </div>
    </van-overlay>
  </div>
  <!-- 细则弹框组件 -->
</template>

<script>
export default {
  name: "RuleModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.rule-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .content {
    background: #7f5fc9;
    border-radius: 20px;
    padding: 30px 18px;
    box-sizing: border-box;
    color: #fff;
    width: 85%;
    margin: 0 auto;
    max-height: min(60vh, calc(100dvh - 120px));
    overflow: auto;
    border: 1px solid #ffeec0;

    .rule-h1 {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 12px;
    }

    .rule-h2 {
      font-size: 16px;
      font-weight: 700;
      margin: 18px 0 10px;
      line-height: 1.35;

      &:first-of-type {
        margin-top: 0;
      }
    }

    .rule-block {
      margin-bottom: 4px;
    }

    .rule-h3 {
      font-size: 15px;
      font-weight: 700;
      margin: 14px 0 8px;
      line-height: 1.4;
    }

    .rule-h4 {
      font-size: 14px;
      font-weight: 600;
      margin: 12px 0 6px;
      line-height: 1.4;
    }

    .rule-p {
      margin: 0 0 8px;
      font-size: 12px;
      line-height: 1.65;
      text-align: justify;

      &--mt {
        margin-top: 4px;
      }

      &--strong {
        font-weight: 600;
      }

      &--note {
        font-weight: 600;
      }
    }

    .rule-em {
      font-weight: inherit;

      &--red {
        color: #ff0000;
      }
    }
  }
  .close-btn {
    margin-top: 16px;
    width: 24px;
    height: 24px;

    img {
      width: 100%;
    }
  }
}
</style>
